<template>
  <div class="pharmacy">
    
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
    }
  },
  mounted(){
    
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.pharmacy{
  overflow: scroll;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/pharmacy/Pharmacy.vue